/* eslint-disable array-callback-return */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

import { toast } from "react-toastify"; //토스트(toast)
import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import InfiniteScroll from "react-infinite-scroll-component";
//import ContentItem from '../../components/ContentItem'

import CustomerNoticeItemNew from "../../components/customer/CustomerNoticeItemNew";
import { isMobile, isAndroid, isIOS } from "react-device-detect";

class MyQnaNew extends Component {
  state = {
    category: 0,
    board_id: 9, //게시판 번호 등록 할 것........
    //title: '',
    //content: '',
    gotoPage: 1,
    pageCount: 1,
    pageSize: 20,
    boardList: [],
    write: false,
    hasMore: false,
    allSelect: false,
    checkItem: [],
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { board_id, gotoPage, category } = this.state;

    this._getBoardData(board_id, gotoPage, category);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getBoardData = async (board_id, gotoPage, category) => {
    const result = await this._getBoardDataApi(board_id, gotoPage, category);
    if (result) {
      const intReturn = result.data[0].intReturn;
      const con = result.data[0].con;
      const pageCount = result.data[0].pageCount;
      const boardList = result.data[0].listData;

      ////console.log(intReturn)
      ////console.log(con)
      if (this._isMounted) {
        if (intReturn === 0) {
          if (con > 0) {
            //console.log('con > 0')
            this.setState({
              gotoPage: gotoPage,
              con: con,
              pageCount: pageCount,
              boardList: boardList,
              hasMore: pageCount < gotoPage ? false : true,
            });
          } else {
            //console.log('con < 0')
            this.setState({
              gotoPage: 1,
              pageCount: 1,
              con: con,
              boardList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        } else {
          //console.log('intReturn <> 0')
          this.setState({
            gotoPage: 1,
            pageCount: 1,
            con: con,
            boardList: [],
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      }
    }
  };
  _getBoardDataApi = (board_id, gotoPage, category) => {
    const { apiUrl, loginId, authId, pkg, history } = this.props;
    const at = localStorage.getItem("at");
    ////console.log(sameCode)

    //POST 방식으로 바꿀수도 있음...
    return axios
      .post(
        apiUrl + "/boardList_pkg",
        {
          params: {
            board_id: board_id,
            gotoPage: gotoPage,
            category: category,
            userid: loginId,
            authId: authId,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: "bearer " + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push("/login");
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const { board_id, gotoPage, category } = this.state;

    const rt = localStorage.getItem("rt");

    if (rt === "" || rt === undefined || rt === null) {
      history.push("/login");
      return false;
    }

    const { data } = await axios.post(apiUrl + "/refreshToken", {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem("at", data[0].at);
      this._getBoardData(board_id, gotoPage, category);
    } else {
      this.setCookie("account", "");

      setLoginId("");
      setAuthId("");

      setTimeout(() => {
        history.push("/login");
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie =
      name +
      "=" +
      value +
      ";expires=" +
      expires +
      ";path=/; SameSite=None; Secure; domain=aniplustv.com";
  };
  _renderItem = () => {
    const { boardList } = this.state;

    const list = boardList.map((item, index) => {
      return (
        <CustomerNoticeItemNew
          key={index}
          index={index}
          idx={item.idx}
          refo={item.refo}
          step={item.step}
          re_level={item.re_level}
          userid={item.userid}
          nicName={item.nicName}
          board_id={item.board_id}
          title={item.title}
          writeDay={item.writeDay}
          charac_img={item.charac_img}
          categoryID={item.categoryID}
          categoryName={item.categoryName}
          content={item.content}
          replay_idx={item.replay_idx}
          onItemDel={this._onItemDel}
          numm={item.numm}
          chkNotice={item.chkNotice}
          selected={item.selected}
          _selected={this._selected}
        />
      );
    });

    return list;
  };
  _changeCategory = (category) => {
    const { board_id } = this.state;
    this.setState({
      category,
    });
    setTimeout(() => {
      this._getBoardData(board_id, 1, category);
    }, 500);
  };
  /*
    _onChange = (e) => {
        //console.log(e.target.value)
        this.setState({
            category: e.target.value
        })
    }
    _textChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    _onContentChange = (e) => {
      
        this.setState({
            content: e
        })
    }
    
    _onSubmit = async () => {
        const { loginId } = this.props;
        const { title, content, category, board_id } = this.state;
        if(loginId === '' || loginId === null || loginId === undefined) {
            toast.warn('로그인후 이용해 주세요.')
            return;
        }
        if(title === '' || title === null || title === undefined) {
            toast.warn('제목을 입력해 주세요.')
            return;
        }
        if(content === '' || content === null || content === undefined) {
            toast.warn('내용을 입력해 주세요')
            return;
        }
        if(category === '' || category === null || category === undefined || category === 100) {
            toast.warn('분류를 선택해 주세요')
            return;
        }

        const result = await this._onSubmitApi()
        const intReturn = result.data[0].intReturn;
        
        if(intReturn === 0) {
            toast.success('1:1 문의가 성공적으로 등록되었습니다.')
            this.setState({
                title: '',
                content: '',
                category: 0,
                write: false
            })

            this._getBoardData(board_id, 1, category)
        }

        ////console.log(title)
        ////console.log(content)
    }
    */
  /*
    _onSubmitApi = () => {
        const { apiUrl, loginId } = this.props;
        const { title, content, board_id, category, imgName } = this.state;

        return axios.post(apiUrl + '/boardWrite', {
            params: {
                userid: loginId,
                board_id: board_id,
                title: title,
                category: category,
                content: content,
                imgName
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
    }
    */
  _showWrite = () => {
    const { write } = this.state;
    this.setState({
      write: !write,
    });
  };
  /*
    _onSelectFile = (e) =>{
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
          this.setState({
            file : file,
            fileName: file.name
          })
        }
        reader.readAsDataURL(file);

        //이미지 업로드 처리.
        this._imgUpload(file)
       
       
    }
    _imgUpload = async (file) => {
        const { loginId, aspUrl } = this.props;
        const formData = new FormData();
        formData.append('img', file);
        formData.append('userid', loginId);
        // 서버의 upload API 호출
        //alert(0)
        const result = await axios.post(aspUrl + '/boardImgUpload.asp', formData);
        const intReturn = result.data[0].intReturn
        const imgName = result.data[0].imgName
        if(intReturn === 0) {
            this.setState({
                imgName
            })
        }
        ////console.log(res)
        
    }
    */
  /*
    _onItemDel = async (idx) => {

        //console.log('asdfasdfasdfdas')

        const { board_id, category } = this.state;
        const { loginId } = this.props;
        if(loginId === null || loginId === undefined || loginId === '') {
            //console.log('not login')
        } else {
            //console.log('start del')
            const result = await this._onItemDelApi(idx)
            const intReturn = result.data[0].intReturn;

            //console.log(intReturn)
            if(intReturn === 0) {
                toast.success('글이 성공적으로 삭제되었습니다.')
                this._getBoardData(board_id, 1, category)
            }
        }
    }
    _onItemDelApi = (idx) => {
        const { apiUrl, loginId, authId } = this.props;

        return axios.post(apiUrl + '/boardDel', {
            params: {
                userid: loginId,
                authId: authId,
                idx: idx
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })

    }
    */
  _renderPage = () => {
    const { gotoPage, con, pageCount } = this.state;

    const dataPerPage = isMobile ? 5 : 10; //한페이지에 보여질 갯수
    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: "pointer" }}
          onClick={() => this._getData(num)}
          className={gotoPage === num ? "on" : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount1 ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: "#000" }}></span>
        )}
        {list}
        {next > pageCount1 && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: "#000" }}></span>
        )}
      </Fragment>
    );
  };

  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn("페이지의 처음입니다.");
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn("페이지의 마지막입니다.");
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  _CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = "";
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = "," + (parseInt(str) % 1000) + "00" + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = "," + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ",0" + (parseInt(str) % 1000) + Money;
          else Money = ",00" + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _allSelect = () => {
    const { allSelect, boardList } = this.state;

    boardList.map((item, index) => {
      if (!allSelect) {
        item.selected = item.idx;
      } else {
        item.selected = 0;
      }
    });

    this.setState({
      allSelect: !allSelect,
    });
  };

  _selected = (index, idx) => {
    const { boardList } = this.state;

    if (boardList[index].selected === 0) {
      boardList[index].selected = idx;
    } else {
      boardList[index].selected = 0;
    }

    this.setState({
      boardList,
    });
  };
  _alertDel = () => {
    // const { loginId } = this.props;
    const { boardList } = this.state;

    let delList = [];
    boardList.find((item, index) => {
      if (item.selected !== 0) {
        delList.push(item.idx);
      }
    });

    if (delList.length <= 0) {
      toast.warn("삭제할 글이 존재하지 않습니다.");
    } else {
      let stringCode = "";
      delList.map((item, index) => {
        stringCode = stringCode + item + "|";
      });

      confirmAlert({
        title: "선택글 삭제",
        message:
          "선택하신 글을 모두 삭제하시겠습니까? 삭제된 글은 복구되지 않습니다.",
        buttons: [
          {
            label: "삭제",
            onClick: () => {
              this._del(stringCode);
            },
          },

          {
            label: "취소",
            //onClick: () => alert('Click No')
          },
        ],
      });
    }
  };
  _del = async (stringCode) => {
    const result = await this._delApi(stringCode);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      this._getBoardData(1);
    }
  };

  _delApi = (stringCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/boardSelectDel", {
        params: {
          userid: loginId,
          stringCode: stringCode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        console.log("error..");
      });
  };
  render() {
    //const { tabIndex } = this.props.childProps;
    //const { hasMore, dataList, gotoPage, con } = this.state;
    // const { loginId } = this.props;
    const { boardList, con, allSelect } = this.state;
    return (
      <Fragment>
        <div className="list_wrap">
          <div className="listHead">
            <span className="total">
              총 <em>{this._CommaFormatted(con)}</em>개
            </span>
            <div className="fl_rt">
              <button
                type="button"
                className="btn_del"
                onClick={this._alertDel}
              >
                선택삭제
              </button>
              <input
                type="checkbox"
                className="chkBox"
                name="chk"
                id="chkAll"
                checked={allSelect}
                onChange={this._allSelect}
              />
              <label htmlFor="chkAll" className="chk"></label>
            </div>
          </div>
          <div className="list wrote">
            {boardList ? this._renderItem() : null}
          </div>
          <div className="page_no">{boardList ? this._renderPage() : null}</div>
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyQnaNew));
